/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState } from "react";
import { Link } from "react-router-dom";

import "swiper/css"; // استيراد أنماط المكتبة
import "swiper/css/navigation";

const Landing = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const cardsData = [
    { id: 3, image: "/assets/3.png", title: "أسمدة", link: "/fertilizers" },
    { id: 4, image: "/assets/4.jpg", title: "منظمات نمو", link: "/pgr" },
    { id: 1, image: "/assets/1.png", title: "مبيدات", link: "/pesticides" },
    { id: 2, image: "/assets/2.png", title: "بذور تقاوي", link: "/seeds" },
  ];

  const faqs = [
    {
      question: "ما هي المبيدات الزراعية؟",
      answer: [
        "تعتبر المبيدات جزءًا أساسيًا في إدارة المحاصيل والحفاظ على الإنتاج الزراعي",
      ],
    },
    {
      question: "ما أهمية المبيدات الزراعية؟",
      answer: [
        "زيادة الإنتاجية: تساعد المبيدات في حماية المحاصيل من الآفات والأمراض، مما يزيد من الإنتاج الزراعي.",
        "تحسين جودة المحاصيل: من خلال مكافحة الأمراض والآفات، يمكن تحسين جودة المنتجات الزراعية.",
        "خفض الفاقد: تساهم في تقليل الخسائر الناتجة عن الأضرار التي قد تلحق بالمحاصيل من قبل الآفات.",
      ],
    },
    {
      question: "ما هي أنواع المبيدات الزراعية؟",
      answer: [
        "المبيدات الحشرية: تُستخدم للقضاء على الحشرات التي تتغذى على النباتات أو تنقل الأمراض.",
        "مبيدات الأعشاب: تُستخدم للتحكم في نمو الأعشاب الضارة التي تنافس النباتات المزروعة على الموارد مثل الماء والعناصر الغذائية.",
        "المبيدات الفطرية: تُستخدم لمنع أو علاج الأمراض الفطرية التي تصيب النباتات .",
        "مبيدات القوارض: تستخدم للتحكم في القوارض مثل الفئران التي قد تتلف المحاصيل.",
        "مبيدات البكتيريا: تهدف إلى القضاء على البكتيريا المسببة للأمراض النباتية مثل مرض التبقع البكتيري.",
        "مبيدات النيماتودا: تُستخدم لتساعد في القضاء علي النيماتودا والحد من تأثيراتها السلبية .",
      ],
    },
    {
      question: "ما هي الفئات الأساسية للمبيدات؟",
      answer: [
        "المبيدات الجهازية: تمتصها النباتات وتنتقل عبر أنسجتها، مما يجعلها فعّالة ضد الآفات التي تتغذى على النبات.",
        "المبيدات التلامسية: تؤثر فقط عند ملامستها للآفة مباشرة.",
        "المبيدات التربوية: تُستخدم للتحكم في الآفات الموجودة في التربة، مثل الديدان والحشرات التحت سطحية.",
        "مبيدات معالجة التربة: حيث تُستخدم للتحكم في الآفات الموجودة في التربة،",
      ],
    },
    {
      question: "ما هي تقنيات استخدام المبيدات بفعالية؟",
      answer: [
        "التوقيت الصحيح: يجب رش المبيدات في الوقت المناسبة.",
        "المعدل الصحيح: استخدام الكمية الصحيحة من المبيد لتجنب الإفراط أو القليل من المادة الفعالة.",
        "الظروف الجوية: رش المبيدات في أوقات الرياح المنخفضة لتقليل التبخر والتأثيرات السلبية.",
      ],
    },
    {
      question: "ما هي الإجراءات الوقائية في استخدام المبيدات؟",
      answer: [
        "استخدام المبيدات بشكل معتدل: يجب اتباع التعليمات الواردة في ملصق المبيد لتجنب الاستخدام المفرط.",
        "التبديل بين المبيدات: لتقليل مخاطر مقاومة الآفات، يُفضل التبديل بين أنواع مختلفة من المبيدات.",
        "استخدام معدات الحماية الشخصية: لضمان السلامة، يجب على المزارعين استخدام معدات حماية مثل القفازات والملابس الواقية والكمامات.",
        "اتباع فترات الأمان: يجب الالتزام بفترات الأمان بين رش المبيدات وجني المحاصيل لتقليل المخاطر الصحية.",
      ],
    },
    {
      question: "ما هي الأسمدة الزراعية؟",
      answer: [
    "هي مواد تُضاف إلى التربة أو النباتات لتزويدها بالعناصر الغذائية الأساسية التي تحتاجها النباتات للنمو والتطور. تساهم الأسمدة في تحسين خصوبة التربة وزيادة الإنتاجية الزراعية.",
      ],
    },
    {
      question: "ما هي أهمية الأسمدة الزراعية؟",
      answer: [
        "زيادة الإنتاجية: توفر الأسمدة العناصر الغذائية الأساسية التي تحتاجها النباتات لتعزيز نموها وزيادة إنتاج المحاصيل.",
        "تحسين خصوبة التربة: تساعد الأسمدة  في إعادة العناصر الغذائية التي تستهلكها المحاصيل، مما يساهم في تحسين صحة التربة على المدى الطويل.",
        "تعزيز صحة النبات: توفر الأسمدة العناصر الغذائية التي تعزز مقاومة النباتات للأمراض والإجهاد البيئي.",
        "تحسين جودة المحاصيل: تلعب الأسمدة دورًا في تحسين الحجم، اللون، وطعم المحاصيل.",
      ],
    },
    {
      question: "ما هي أنواع الأسمدة الزراعية؟",
      answer: [
        "الأسمدة العضوية: تحتوي على نسبة عالية من المواد العضوية. تحسن خصوبة التربة بشكل تدريجي، تعزز النشاط البيولوجي في التربة، وتساعد في امتصاص العناصر الغذائية.",
        "الأسمدة الكيميائية: هي أسمدة مصنعة من مركبات كيميائية تحتوي على العناصر الغذائية الأساسية مثل النيتروجين (N)، الفسفور (P)، والبوتاسيوم (K).",
        " الاسمدة المعدنية: تحتوي على عناصر غذائية ثانوية مثل الحديد (Fe)، المغنيسيوم (Mg)، الكبريت (S)، الزنك (Zn)، النحاس (Cu). تستخدم بكميات صغيرة ولكنها مهمة لتحسين صحة النباتات وتحفيز عملية التمثيل الضوئي.",
        " الاسمدة السائلة: تحتوي على العناصر الغذائية بشكل سائل، مما  ",
        "أسمدة نيتروجينية: (مثل اليوريا، نترات الأمونيوم)  تعزز نمو الأوراق والجزء الخضري للنبات.",
        "أسمدة فوسفاتية: (مثل سوبر فوسفات الكالسيوم)  تحفز نمو الجذور وتزيد من إنتاج الزهور والفواكه.",
        "أسمدة بوتاسية: (مثل سلفات البوتاسيوم)  تعزز مقاومة النبات للأمراض والظروف البيئية القاسية.",
        "الأسمدة المركبة: هي أسمدة تحتوي على مزيج من العناصر الأساسية (النيتروجين، الفسفور، والبوتاسيوم) بنسب متوازنة لتلبية احتياجات النباتات في مراحل النمو المختلفة . يتم استخدامها لتحقيق تغذية متكاملة ومتوازنة للنبات.",
        "الأسمدة السائلة: تحتوي على العناصر الغذائية بشكل سائل، مما يجعل امتصاصها أسرع من الأسمدة الصلبة وتُستخدم في الري أو الرش على الأوراق. ",
        "أسمدة بطيئة الاطلاق (Slow-release fertilizers): تم تصميمها للإفراج عن العناصر الغذائية تدريجيًا على مدى فترة زمنية، مما يمنع الإفراط في التغذية ويحسن كفاءة الاستخدام.",
      ],
    },
    {
      question: "ما هي  منظمات نمو النبات؟",
      answer: [
        "منظمات نمو النبات تساهم في تحسين خصائص النمو والإزهار والنضج، مما يعزز الإنتاجية وجودة المحاصيل. وتعتبر منظمات نمو النبات هي مواد كيميائية تؤثر على نمو وتطور النباتات، سواء كانت طبيعية أو صناعية. تعمل هذه المنظمات على تحفيز أو تثبيط بعض العمليات الفسيولوجية في النباتات مثل النمو، الإزهار، الإثمار، والتورم.",
      ],
    },
    {
      question: "ما هي أهمية منظمات نمو النبات؟",
      answer: [
        "تحسين الإنتاجية",
        "مكافحة الإجهاد",
        "تنظيم النضج",
        "تحسين جودة المحاصيل",
        "تحفيز النمو",
      ],
    },
    {
      question: "ما هي أنواع منظمات نمو النبات؟",
      answer: [
        {
          sampil: "الهرمونات الطبيعية مثل :",
        },
        "الأوكسينات (Auxins): تُساهم في نمو الجذور، تحفيز الانقسام الخلوي، والتحكم في نمو السيقان.",
        "الجيبرلينات (Gibberellins): تحفز نمو السيقان والأزهار، وتزيد من حجم الفواكه.",
        "السيتوكينينات (Cytokinins): تحفز الانقسام الخلوي في النبات وتساعد في نمو الأنسجة.",
        "الأبسيسيك أسيد (Abscisic acid): يساعد في تقليل فقد الماء خلال الجفاف، ويمنع النمو في حالات الإجهاد.",
        "الإيثيلين (Ethylene): يساعد في نضج الفواكه ويساهم في تساقط الأوراق.",
        {
          sampil: "الهرمونات الصناعية مثل : ",
        },
        "2,4D يُستخدم بشكل رئيسي كمبيد أعشاب، ولكنه يؤثر أيضًا على نمو النباتات.",
        "Benzyl adenine يُستخدم لتحفيز النمو الخضري والإزهار في بعض المحاصيل.",
        "Ethephon يُستخدم في نضج الفواكه مثل الموز والطماطم.",
      ],
    },
  ];

  return (
    <>
      <main>
        {/* Hero Section */}
        <section className="hero-section">
          <div className="container">
            <div className="hero-data">
              <div className="Hero-text">
                <h1>معًا نحــــو زراعة أكثر إنتاجًا وأمانًا</h1>
                <p>مع خبرة وجودة لضمان أفضل النتائج</p>
                <div className="btns">
                  <a className="btn-green" href="#about">
                    أعرف أكتر
                  </a>

                  <a
                    className="btn-white"
                    href="https://wa.me/+201068063055?text= السلام عليكم كنت عاوز أستفسر عن منتجات حضراتكم "
                  >
                    تواصل معنا
                  </a>
                </div>
              </div>
              <img src="/assets/Hero-image.png" alt="Hero Image" />
            </div>
          </div>
        </section>
        {/* About */}
        <section className="about-section" id="about">
          <h1 className="title">من نحن</h1>
          <div className="container">
            <div className="img-container">
              <img src="/assets/About-us.png" alt="" />
            </div>
            <div className="about-txt">
              <h1>التأسيس</h1>
              <p>
                تأسست مؤسسة البركة في عام 1994، وبدأت مشوارها كشريك موثوق في
                القطاع الزراعي، ملتزمة بتلبية احتياجات المزارعين من خلال توفير
                منتجات عالية الجودة تشمل المبيدات الزراعية ، الأسمدة ، المخصبات
                والبذور. يقع مقرنا في مدينة بلقاس- محافظة الدقهلية- جمهورية مصر
                العربية. منذ البداية، كانت مهمتنا هي تقديم حلول زراعية مبتكرة
                ومتكاملة، بالإضافة إلى تقديم الإستشارات والدعم العملي للمزارعين
                لتحقيق أفضل نتائج في زراعتهم.
              </p>
            </div>
          </div>
        </section>
        {/* Vision */}
        <section className="vision-section">
          <h1 className="title">رؤيتنا وأهدافنا</h1>
          <div className="container">
            <div className="vision-txt">
              <p>
                <span className="V-M-2">رؤيتنا:</span>
                نسعى في مؤسسة البركة لأن نكون شريكًا موثوقًا في دعم الزراعة
                المستدامة من خلال تقديم حلول مبتكرة تُحسن الإنتاجية وتعزز
                الاستدامة. نحن ملتزمون بتوفير أفضل المنتجات الزراعية التي تلبي
                احتياجات المزارعين وتدعمهم في تحقيق أقصى استفادة من مواردهم.
                <br />
                <br />
                <span className="V-M-2">مهمتنا:</span>
                <span className="V-M">التركيز على المزارعين:</span>
          نحن نؤمن بأن نجاح المزارعين هو نجاح لنا،
                ومن أجل ذلك نقدم لهم استشارات متخصصة ونحلل احتياجاتهم بدقة
                لتقديم أفضل الحلول الزراعية. "نحن هنا لدعمك في كل خطوة" .
                <br />
                <span className="V-M">الاستدامة والإنتاجية:</span>
                نعمل على دعم الزراعة المستدامة من خلال
                توفير مبيدات زراعية ، أسمدة وتقاوي تحقق أعلى معدلات الإنتاجية
                والجودة. فإن مؤسسة البركة ليست مجرد مورد للمنتجات الزراعية، بل
                هي جزء من رؤية أكبر لدعم الزراعة المستدامة.
                <br />
                <span   className="V-M">
                التعاون المستمر:
                </span>
 نسعى لبناء علاقات شراكة طويلة
                الأمد مع المزارعين، حيث نكون دائمًا إلى جانبهم في كل خطوة على
                الطريق لتحقيق نجاحات ملموسة.
              </p>
            </div>
          </div>
        </section>
        {/* Timeline */}
        <section className="about-section timeline">
          <h1 className="title">المعالم الرئيسية</h1>
          <div className="container">
            <div className="about-txt">
              <p>
                <span>1994:</span> تأسيس مؤسسة البركة وتوجهها لتلبية احتياجات
                المزارعين من خلال توفير المدخلات الزراعية الأساسية.
                <br />
                <span>2010:</span> إطلاق التقاوي كمنتج رئيسي ضمن محفظتنا،
                والمصممة لتحقيق أقصى استفادة من نمو المحاصيل وزيادة إنتاجيتها.
                <br />
                <span>2012 <span >(حتى الآن)</span>:</span> توسيع نشاطنا ليشمل استيراد المبيدات الزراعية
                والأسمدة والمخصبات عالية الجودة، وتقديم مجموعة متنوعة من الحلول
                الزراعية التي تساهم في مواجهة التحديات الزراعية.
              </p>
            </div>
            <div className="img-container">
              <img src="/assets/About2.png" alt="about-image" />
            </div>
          </div>
        </section>
        <section className="products-section" id="products">
          <h1 className="title">المنتجات</h1>
          <div className="container">
            <div className="products-cards">
              {cardsData.map((card) => (
                <Link key={card.id} to={card.link} className="card-link">
                  <div className="card">
                    <img
                      src={card.image}
                      alt={card.title}
                      className="card-image"
                    />
                    <div className="card-content">
                      <h2 className="card-title">{card.title}</h2>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
            {/* <div className="img-container">
              <img src="/assets/About2.png" alt="about-image" />
            </div> */}
          </div>
        </section>

        {/* Map */}

        {/*                
        <section id="CTA">
          <h1>كن واعي بـ أسرتك الان</h1>
          <div className="links-CTA" style={{ display:"flex",gap:"30px"}}>
          <a target="_blank" href="https://wa.me/+201040031584?text=السلام%20عليكم%20كنت%20عاوز/ة%20أعرف%20تفاصيل">نزل التطبيق IOS</a>
          <a target="_blank" href="https://wa.me/+201040031584?text=السلام%20عليكم%20كنت%20عاوز/ة%20أعرف%20تفاصيل">نزل التطبيق  Andriod</a>
          </div>
        </section> */}

        <section id="FAQ">
          <h1 className="title">الأسئلة الشائعة</h1>
          <div className="container">
            <div className="FAQ-box">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className={`faq-item ${
                    activeIndex === index ? "active" : ""
                  }`}
                >
                  <div
                    className="faq-question"
                    onClick={() => toggleFAQ(index)}
                  >
                    {faq.question}
                    <span className="icon">
                      {activeIndex === index ? "-" : "+"}
                    </span>
                  </div>
                  <div
                    className="faq-answer"
                    style={{
                      display: activeIndex === index ? "block" : "none",
                    }}
                  >
                    <ul className="FAQ-ul">
                      {faq.answer.map((point, i) => (
                        point.sampil ? (
                          <p  key={i} className="sampil" style={{color:"#3C240A" , margin:"20px 0",}}>{point.sampil}</p>
                        ):
                        <li key={i}>{point}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="map-section" id="location">
          <h2 className="map-title">موقعنا على الخريطة</h2>
          <div className="map-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d358.664127531365!2d31.358226804598278!3d31.214981273081577!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzHCsDEyJzUzLjkiTiAzMcKwMjEnMzAuNSJF!5e0!3m2!1sen!2seg!4v1742962383735!5m2!1sen!2seg"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="El Baraka Location Map"
            ></iframe>
          </div>
        </section>
      </main>
    </>
  );
};

export default Landing;
